module.exports = __webpack_public_path__ + "static/media/2.eb2d40ab.JPG";